function initSelleasyMetafield() {
  const containers = document.querySelectorAll("[data-selleasy]")
  if (!containers.length) return

  async function addToCart(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    })

    if (!res.ok) {
      const error = await res.json().catch(() => ({}))
      throw new Error(error.description || "Unable to add item to cart")
    }

    return res.json()
  }

  function updateAddButtonText() {
    const addBtn = document.querySelector('button[name="add"]')
    if (!addBtn || addBtn.disabled) return
    const span = addBtn.querySelector("span")
    if (!span) return
    const checkedCount = [
      ...document.querySelectorAll("[data-selleasy-checkbox]:checked:not(:disabled)"),
    ].length
    if (!span.querySelector(".selleasy-btn-separator")) {
      span.dataset.originalText = span.textContent.trim()
    }
    if (checkedCount > 0) {
      span.innerHTML = `${span.dataset.originalText} <span class="selleasy-btn-separator" aria-hidden="true"></span> ${checkedCount + 1} items`
      addBtn.classList.add("selleasy-items-selected")
    } else {
      span.textContent = span.dataset.originalText
      addBtn.classList.remove("selleasy-items-selected")
    }
  }

  subscribe(PUB_SUB_EVENTS.variantChange, () => {
    updateAddButtonText()
  })

  function updateItem(item) {
    const checkbox = item.querySelector("[data-selleasy-checkbox]")
    const variants = JSON.parse(item.dataset.selleasyVariants || "[]")
    const selects = [...item.querySelectorAll("[data-selleasy-option-select]")].sort(
      (a, b) => Number(a.dataset.selleasyOptionSelect) - Number(b.dataset.selleasyOptionSelect)
    )
    const selected = selects.map(s => s.value)

    const match = variants.find(
      v =>
        v.available &&
        (selects.length < 1 || v.option1 === selected[0]) &&
        (selects.length < 2 || v.option2 === selected[1]) &&
        (selects.length < 3 || v.option3 === selected[2])
    )

    const img = item.querySelector(".selleasy-row__image img")
    const sizingTip = item.querySelector("[data-selleasy-sizing-tip]")

    if (match) {
      item.dataset.selectedVariantId = String(match.id)
      item.dataset.selectedPreorderDate = match.preorder_date || ""
      if (checkbox) checkbox.disabled = false
      if (img) img.src = match.image || img.dataset.defaultSrc
      if (sizingTip) {
        if (match.sizing_tip) {
          sizingTip.textContent = match.sizing_tip
          sizingTip.style.visibility = ""
        } else {
          sizingTip.style.visibility = "hidden"
        }
      }
    } else {
      item.dataset.selectedVariantId = ""
      item.dataset.selectedPreorderDate = ""
      if (checkbox) {
        checkbox.disabled = true
        checkbox.checked = false
      }
      if (img) img.src = img.dataset.defaultSrc
      if (sizingTip) sizingTip.style.visibility = "hidden"
    }
    updatePreorderAlert(item)
    updateAddButtonText()
  }

  function updatePreorderAlert(item) {
    const textEl = item.querySelector("[data-selleasy-preorder-text]")
    if (!textEl) return

    const date = item.dataset.selectedPreorderDate
    if (date) {
      textEl.textContent = `This item is on pre-order and will ship from ${date}.`
      textEl.style.visibility = ""
    } else {
      textEl.style.visibility = "hidden"
    }
  }

  containers.forEach(container => {
    container.querySelectorAll("[data-selleasy-item]").forEach(item => updateItem(item))

    container.querySelectorAll("[data-selleasy-checkbox]").forEach(cb => {
      cb.addEventListener("change", updateAddButtonText)
    })

    container.querySelectorAll("[data-selleasy-option-select]").forEach(select => {
      select.addEventListener("change", () => {
        const item = select.closest("[data-selleasy-item]")
        if (!item) return

        const variants = JSON.parse(item.dataset.selleasyVariants || "[]")
        const selects = [...item.querySelectorAll("[data-selleasy-option-select]")].sort(
          (a, b) =>
            Number(a.dataset.selleasyOptionSelect) - Number(b.dataset.selleasyOptionSelect)
        )

        const changedIndex = Number(select.dataset.selleasyOptionSelect)

        selects.forEach((otherSelect, otherIdx) => {
          if (otherIdx <= changedIndex) return

          const filtered = variants.filter(v => {
            if (!v.available) return false
            for (let k = 0; k < otherIdx; k++) {
              if (v[`option${k + 1}`] !== selects[k].value) return false
            }
            return true
          })

          const optionKey = `option${otherIdx + 1}`
          const availableValues = [...new Set(filtered.map(v => v[optionKey]).filter(Boolean))]
          const prevValue = otherSelect.value

          otherSelect.replaceChildren(
            ...availableValues.map(val => new Option(val, val, false, val === prevValue))
          )

          if (!availableValues.includes(prevValue) && availableValues.length > 0) {
            otherSelect.value = availableValues[0]
          }
        })

        updateItem(item)
      })
    })

    const splitboardSelect = document.getElementById("selleasy-splitboard-select")
    if (!splitboardSelect) return

    const skinsItems = container.querySelectorAll("[data-selleasy-skins-item]")

    function syncSkinsVariant() {
      const selectedOption = splitboardSelect.options[splitboardSelect.selectedIndex]
      const skinsGroup = selectedOption?.dataset.skinsGroup
      const trimToFit = selectedOption?.dataset.trimToFit

      skinsItems.forEach(skinsItem => {
        const targetValue = skinsItem.dataset.skinStyle === "pre-cut" ? skinsGroup : trimToFit
        if (!targetValue) return

        const variants = JSON.parse(skinsItem.dataset.selleasyVariants || "[]")

        for (const select of skinsItem.querySelectorAll("[data-selleasy-option-select]")) {
          const optionIdx = Number(select.dataset.selleasyOptionSelect)
          const optionKey = `option${optionIdx + 1}`

          const belongsToThisSelect = variants.some(v => v[optionKey] === targetValue)
          if (!belongsToThisSelect) continue

          if (![...select.options].some(o => o.value === targetValue)) {
            select.replaceChildren(new Option(targetValue, targetValue))
          }
          select.value = targetValue
          select.disabled = true
          updateItem(skinsItem)
          break
        }
      })
    }

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data?.variant?.id) {
        splitboardSelect.value = data.variant.id
        syncSkinsVariant()
      }
    })

    syncSkinsVariant()
  })

  let addingSelleasyItems = false

  document.addEventListener("click", e => {
    const addBtn = e.target.closest('button[name="add"]')
    if (!addBtn?.form || addBtn.closest("quick-add-modal")) return
    if (addBtn.getAttribute("aria-disabled") === "true") return
    if (addingSelleasyItems) return e.preventDefault()

    const items = []
    containers.forEach(container => {
      container.querySelectorAll("[data-selleasy-item]").forEach(item => {
        const cb = item.querySelector("[data-selleasy-checkbox]")
        if (cb?.checked && !cb.disabled && item.dataset.selectedVariantId) {
          const cartItem = { id: Number(item.dataset.selectedVariantId), quantity: 1 }
          if (item.dataset.selectedPreorderDate) {
            cartItem.properties = {
              "Pre-order": `Ships from ${item.dataset.selectedPreorderDate}`,
            }
          }
          items.push(cartItem)
        }
      })
    })

    if (!items.length) return

    e.preventDefault()
    addingSelleasyItems = true
    addBtn.classList.add("loading")
    addBtn.querySelector(".loading__spinner")?.classList.remove("hidden")

    addToCart(items)
      .catch(err => console.error(err))
      .finally(() => {
        addingSelleasyItems = false
        if (addBtn.form.requestSubmit) addBtn.form.requestSubmit(addBtn)
        else addBtn.form.dispatchEvent(new Event("submit", { cancelable: true }))
      })
  })
}

document.addEventListener("DOMContentLoaded", () => {
  initSelleasyMetafield()
})
